import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import Loading from './components/Loading';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Projects from './pages/Projects';

function AppContent() {
  const [isLoading, setIsLoading] = useState(true);
  const { theme, isLoading: themeLoading } = useTheme();

  useEffect(() => {
    // Apply theme to document
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  const handleLoadingComplete = () => {
    setIsLoading(false);
  };

  // Wait for theme to load before showing content
  if (themeLoading) {
    return <div className="theme-loading">Loading...</div>;
  }

  return (
    <HelmetProvider>
      <div className="App">
        {isLoading && <Loading onLoadingComplete={handleLoadingComplete} />}
        <div className={`main-content ${isLoading ? 'loading' : 'loaded'}`}>
          <Router>
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </Layout>
          </Router>
        </div>
      </div>
    </HelmetProvider>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;

